// hooks/useAtualizarDados.ts
import { useState } from "react";
import { Anuncio } from "../../../interfaces/Anuncio";
import { atualizarAnuncioService } from "../../../services/atualizarAnuncioService";
// --------------------- Import Services ---------------------

export const useAtualizarAnuncio = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const atualizar = async (id: number, data: Partial<Anuncio>) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const atualizarDados = await atualizarAnuncioService(id, data);
      if (atualizarDados) {
        setSuccess(true);
      } else {
        setError(true);
      }
      return atualizarDados;
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    atualizar,
    isLoading,
    isSuccess,
    error,
    success,
    resetError,
    resetSuccess,
  };
};
